import { afterRenderEffect, ChangeDetectionStrategy, Component, inject, signal, DOCUMENT } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { app } from '../../../environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MetaService } from '../../meta.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { PaintDirective } from '../../paint.directive';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'faqs-mt',
  templateUrl: './faq-mt.component.html',
  styleUrls: ['./info.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, RouterLink, MatIconModule, PaintDirective, MatButtonModule]
})
export default class FaqMTComponent {
  fragment = signal<string>('');
  android: string = 'https://play.google.com/store/apps/details?id=' + app.package;
  ios: string = 'https://itunes.apple.com/mt/app/cloudigo/id' + app.id;
  yt: string = 'https://www.youtube.com/channel/UCx0P2nVwtv6Dyk-NV-JElVQ';
  fb: string = 'https://facebook.com/cloudigo';
  activated = inject(ActivatedRoute);
  meta = inject(MetaService);
  document = inject(DOCUMENT);

  constructor() {
    this.activated.fragment.pipe(takeUntilDestroyed()).subscribe(fragment => {
      this.fragment.set(fragment??'');
    });
    this.meta.setTags('cloudigo Malta - Frequently Asked Questions');

    afterRenderEffect(() => {
      const fragment = this.fragment();
      this.onExpand(fragment);
    });
  }

  onExpand(id: string){
    this.fragment.set(id);
    setTimeout(() => {
      let element = this.document.getElementById(id);
      if (element) {
        element.scrollIntoView({behavior: 'smooth' });
      }
    }, 500);
  }
}
